import { render } from "./Urology.vue?vue&type=template&id=25f2e44e&scoped=true"
import script from "./Urology.vue?vue&type=script&lang=ts"
export * from "./Urology.vue?vue&type=script&lang=ts"

import "./Urology.vue?vue&type=style&index=0&id=25f2e44e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-25f2e44e"

export default script